module.exports = __webpack_public_path__ + "static/387-6e9567b6f6ea58b757ae4017c8ca56db.jpg";